import isEqual from 'lodash/isEqual'
import { create } from 'zustand'

import type { IdentifyProperties } from '@src/ampli-web'

type Key = keyof IdentifyProperties
type Value = IdentifyProperties[keyof IdentifyProperties]

type properties = Map<Key, Value>

interface AmplitudeIdentifyStore {
  properties: properties
  setProperties: (properties: IdentifyProperties) => void
  isValueSet: (property: Key, value: Value) => boolean
}

export const useAmplitudeIdentifyStore = create<AmplitudeIdentifyStore>((set, get) => ({
  properties: new Map<Key, Value>(),
  setProperties(properties: IdentifyProperties) {
    set((state) => {
      const newProperties = new Map(state.properties)

      for (const [key, value] of Object.entries(properties)) {
        newProperties.set(key as Key, value as Value)
      }

      return {
        properties: newProperties,
      }
    })
  },

  isValueSet(property: Key, value: Value) {
    return isEqual(get().properties.get(property), value)
  },
}))
